



























































import throttle from 'lodash/throttle';

import CropperDialog from '@/components/core/CropperDialog.vue';
import ThumbnailStreamerPreview from '@/components/ThumbnailStreamerPreview.vue';

import { CropperChangeData, EAspectRatios } from '@/api/schema';
import {
  getThumbnailConfig,
  ETemplateValues,
  IThumbnailConfig
} from '@/helpers/StreamerThumbnailConfigs';
import { PropType } from 'vue';

const PREVIEW_IMAGE_HEIGHT = 80;
const ACCEPTED_TYPE = ['image/webp', 'image/jpeg', 'image/jpg'];
const MAX_FILE_SIZE = 400; // 400kb
const ERROR_TEXT = 'Image in JPEG, JPG or WEBP (file size – up to 400kb)';

export default {
  name: 'ThumbnailImageUploader',
  components: {
    CropperDialog,
    ThumbnailStreamerPreview
  },
  props: {
    imageUrl: {
      type: String,
      default: ''
    },

    cropperHeader: {
      type: String,
      default: 'Create Thumbnail'
    },
    cropperSubmitBtn: {
      type: String,
      default: 'Crop'
    },

    cropAreaWidth: {
      type: Number,
      default: 400
    },
    cropImageWidth: {
      type: Number,
      default: 196
    },
    cropImageHeight: {
      type: Number,
      default: 225
    },

    templateKey: {
      type: String as PropType<ETemplateValues>,
      default: ETemplateValues.TEMPLATE_1
    },
    streamerNickname: {
      type: String,
      default: 'Unknown'
    }
  },
  data(): any {
    return {
      showCropDialog: false,

      localImageBlob: null,
      localImageUrl: null,
      croppedPreviewImageUrl: '',

      cropImage: {
        src: null,
        type: null
      },
      cropCoordinates: null,

      ACCEPTED_TYPE,
      MAX_FILE_SIZE,
      PREVIEW_IMAGE_HEIGHT,
      ERROR_TEXT
    };
  },
  computed: {
    hasFile(): boolean {
      return !!this.localImageBlob;
    },
    hasError(): boolean {
      if (!this.hasFile) return false;

      return !(this.isValidType && this.isValidSize);
    },
    isValidType(): boolean {
      if (!this.hasFile) return true;

      return ACCEPTED_TYPE.includes(this.localImageBlob.type);
    },
    isValidSize(): boolean {
      if (!this.hasFile) return true;

      return this.localImageBlob.size <= this.MAX_FILE_SIZE * 1024;
    },

    cropperStyles(): { [key: string]: string } {
      return {
        width: this.cropAreaWidth + 'px',
        minHeight: this.cropImageHeight + 'px',
        maxHeight: this.cropImageHeight + 'px'
      };
    },
    aspectRatio(): number {
      return this.cropImageWidth / this.cropImageHeight;
    },

    thumbnailConfig(): IThumbnailConfig {
      return getThumbnailConfig(this.templateKey, EAspectRatios.SIXTEEN_NINE);
    }
  },
  methods: {
    handlerOnInputFile: throttle(
      async function (file: Blob): Promise<void> {
        this.localImageBlob = file;
        const url = URL.createObjectURL(file);

        this.localImageUrl = url;

        if (!this.hasFile || !this.isValidType || !this.isValidSize) {
          return;
        }

        this.cropImage = {
          src: url,
          type: file.type
        };

        this.showCropDialog = true;
      },
      500,
      { leading: true }
    ),
    handlerOnChangeCrop(data: CropperChangeData): void {
      this.croppedPreviewImageUrl = data.canvas.toDataURL();
    },
    handlerOnSubmitCrop(data: CropperChangeData): void {
      const { canvas, coordinates } = data;

      this.cropCoordinates = coordinates;

      this.localImageUrl = `${canvas.toDataURL(this.cropImage.type)}`;

      this.emitUpdateImage();
    },
    handlerOnCropClose(): void {
      if (!this.cropCoordinates) {
        this.clearConfiguration();
        return;
      }

      this.emitUpdateImage();
    },
    async emitUpdateImage(): Promise<void> {
      this.$emit('change', this.localImageUrl);
    },
    clearConfiguration(): void {
      this.localImageBlob = null;
      this.localImageUrl = null;
      this.croppedPreviewImageUrl = null;

      if (this.cropImage?.src) {
        this.cropCoordinates = null;
        URL.revokeObjectURL(this.cropImage.src);
      }

      this.$emit('change', null);
    }
  }
};
